import { FC, useMemo } from 'react';

import { ICONS } from '../utils/enum/Icons';

interface Props {
    icon: ICONS;
    style?: React.CSSProperties | undefined;
    classes?: string;
}

const IconComponent: FC<Props> = ({ icon, style = undefined, classes }) => {
    return <i className={`br-icon br-icon-${icon} ${classes}`} style={style}></i>;
};

export default IconComponent;
